export const ENERGY_ANALYSIS_TOPIC = '/topic/energy-analysis';
export enum EnergyAnalysisMessages {
  EnergyAnalysisUpdate = 'EnergyAnalysisUpdateMessage',
}
